// 用户信息
import $axios from "@/utils/$axios";

const userApi = {
  loginUserUrl: "/loginUser",
  loginUrl: "/login",
  registerUrl: '/enterprise/register',
  currencyTypeUrl: "/sysType/currencyType",
  logoutUrl: "https://testpgapi.cailian.net/mgy-main-test/logout",
};

// 登录
export function loginUserFn(params) {
  return $axios({
    url: userApi.loginUserUrl,
    method: "post",
    data: params
  });
}

// 获取用户登录信息
export function loginFn(params) {
  return $axios({
    url: userApi.loginUrl,
    method: "post",
    data: params
  });
}
// 注册用户
export function registerFn(params) {
  return $axios({
    url: userApi.registerUrl,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: params
  });
}
// 通用类接口调用
export function currencyTypeFn() {
  return $axios({
    url: userApi.currencyTypeUrl,
    method: "post"
  });
}

// 退出登录
export function logoutFn() {
  return $axios({
    url: userApi.logoutUrl,
    method: "post"
  });
}
